import { useCallback } from "react";
import useApi from "../useApi";

const BASE = "/suppliers";

export const useCredentialsList = () => {
  const api = useApi(`${BASE}/credentials`, {
    method: "GET",
    immediate: true,
    errorMessage: "Failed to fetch credentials",
    transformResponse: (res) => (Array.isArray(res?.data) ? res.data : []),
  });

  const refetch = async () => {
    try {
      const res = await api.execute();
      return { success: true, data: res };
    } catch (err) {
      return { success: false, message: err.response?.data?.message || "Failed to fetch credentials" };
    }
  };

  return {
    data: api.data ?? [],
    loading: api.loading,
    error: api.error,
    refetch,
  };
};

export const useCredentialById = (credentialId) => {
  const url = useCallback(
    () => `${BASE}/credentials/${credentialId}`,
    [credentialId]
  );

  const api = useApi(url, {
    method: "GET",
    immediate: !!credentialId,
    errorMessage: "Failed to fetch credential",
    transformResponse: (res) => res?.data ?? null,
  });

  return {
    data: credentialId ? api.data : null,
    loading: api.loading,
    error: api.error,
    refetch: api.refetch,
  };
};

export const useCreateCredential = () =>
  useApi(`${BASE}/credentials`, { method: "POST" });
